import axios from 'axios';

import { getLocalToken } from "../services/localStorage";

const api = axios.create({
  baseURL: 'https://scanner-prova.rj.r.appspot.com/'
});

export const getSystemsData = async () => {
  const token = getLocalToken();
  const res = await api.get('govbr/modulos-plataforma/', {
    headers:{
      'Authorization': `Bearer ${token}`
    }
  });

  return res.data;
}

export const getSystemsResources = async () => {
  const token = getLocalToken();
  const res = await api.get('govbr/modulos-plataforma/recurso/', {
    headers:{
      'Authorization': `Bearer ${token}`
    }
  });

  return res.data;
}

